"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastProvider = exports.ToastContext = exports.REMOVE_TOP_TOAST = exports.REMOVE_BOTTOM_TOAST = exports.ADD_TOP_TOAST = exports.ADD_BOTTOM_TOAST = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable indent */
var ADD_TOP_TOAST = exports.ADD_TOP_TOAST = function ADD_TOP_TOAST(toast) {
  return {
    type: "add-toast-top",
    toast: toast
  };
};
var ADD_BOTTOM_TOAST = exports.ADD_BOTTOM_TOAST = function ADD_BOTTOM_TOAST(toast) {
  return {
    type: "add-toast-bottom",
    toast: toast
  };
};
var REMOVE_TOP_TOAST = exports.REMOVE_TOP_TOAST = function REMOVE_TOP_TOAST(toast) {
  return {
    type: "remove-toast-top",
    toast: toast
  };
};
var REMOVE_BOTTOM_TOAST = exports.REMOVE_BOTTOM_TOAST = function REMOVE_BOTTOM_TOAST(toast) {
  return {
    type: "remove-toast-bottom",
    toast: toast
  };
};
var ToastContext = exports.ToastContext = /*#__PURE__*/(0, _react.createContext)();
var initialState = {
  topToasts: [],
  bottomToasts: []
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case "add-toast-top":
      return _objectSpread(_objectSpread({}, state), {}, {
        topToasts: [].concat((0, _toConsumableArray2["default"])(state.topToasts), [action.toast])
      });
    case "add-toast-bottom":
      return _objectSpread(_objectSpread({}, state), {}, {
        bottomToasts: [].concat((0, _toConsumableArray2["default"])(state.bottomToasts), [action.toast])
      });
    case "remove-toast-top":
      return _objectSpread(_objectSpread({}, state), {}, {
        topToasts: state.topToasts.filter(function (t) {
          return t != action.toast;
        })
      });
    case "remove-toast-bottom":
      return _objectSpread(_objectSpread({}, state), {}, {
        bottomToasts: state.bottomToasts.filter(function (t) {
          return t != action.toast;
        })
      });
  }
};
var ToastProvider = exports.ToastProvider = function ToastProvider(_ref) {
  var children = _ref.children;
  var _useReducer = (0, _react.useReducer)(reducer, initialState),
    _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  return /*#__PURE__*/_react["default"].createElement(ToastContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children);
};
ToastProvider.propTypes = {
  children: _propTypes["default"].node
};